import React, { useCallback, useContext, useState } from 'react';
import SignInModalContainer from '../containers/modals/SignInModalContainer';
import SignUpModalContainer from '../containers/modals/SignUpModalContainer';
import CreateOrUpdateGuestModal from '../components/modals/CreateOrUpdateGuestModal';
import ConfirmationModal from '../components/modals/ConfirmationModal';
import CreateNewActivityModal from '../components/modals/CreateNewActivityModal';
import EmaillogModal from '../components/modals/EmaillogModal';
import CancellationModal from '../components/modals/CancellationModal';
import AvailableAddonsModal from '../components/modals/AvailableAddonsModal';
import CreateNewActivityTagModal from '../components/modals/CreateNewTagModal';
import MultipleTicketModal from '../components/modals/MultipleTicketModal';
import ConfirmOrDenyBookingModal from '../components/modals/ConfirmOrDenyBookingModal';
import AvailableTimeslotsModal from '../components/modals/AvailableTimeslotsModal';
import ImageSliderModal from '../components/modals/ImageSliderModal';
import FullscreenMessageModal from '../components/modals/FullscreenMessageModal';
import DuplicateTicketModal from '../components/modals/DuplicateTicketModal';
import ResendEmailModal from '../components/modals/ResendEmailModal';
import CreateNewUserGroupModal from '../components/modals/CreateNewUserGroupModal';
import CalendarEventInfo from '../components/modals/CalendarEventInfo';
import KeepCartModal from '../components/modals/KeepCartModal';
import AddAgentModal from '../components/modals/AddAgentModal';
import AddAgentListModal from '../components/modals/AddAgentListModal';
import AcceptBookingNoteModal from '../components/modals/AcceptBookingNoteModal';
import UnsavedModificationsModal from '../components/modals/UnsavedModificationsModal';
import CreateNewChainModal from '../components/modals/CreateNewChainModal';
import CreateNewDiscountPackageModal from '../components/modals/CreateNewDiscountPackageModal';
import ImportActivityModal from '../components/modals/ImportActivityModal';
import CreateNewIslandModal from '../components/modals/CreateNewIslandModal';
import CreateNewCancelReasonModal from '../components/modals/CreateNewCancelReasonModal';
import SelectPrintMethodModal from '../components/modals/SelectPrintMethodModal';
import DragDropModal from '../components/modals/DragDropModal';
import SendSmsModal from '../components/modals/SendSmsModal';
import TestItineraryModal from '../components/modals/TestItineraryModal';
import BookingEditRefundModal from '../components/modals/BookingEditRefundModal';
import BookingEditTimeModal from '../components/modals/BookingEditTimeModal';
import SendEmailModal from '../components/modals/SendEmailModal';
import CreateOrEditPriceItemNameModal from '../components/modals/CreateOrEditPriceItemNameModal';
import SendPaymentLinkModal from '../components/modals/SendPaymentLinkModal';
import SoftLockModal from '../components/modals/SoftLockModal';
import DashboardAlertsModal from '../components/modals/DashboardAlertsModal';
import BulkRefundCancelModal from '../components/modals/BulkRefundCancelModal';

export const MODAL_TYPE = {
    SIGNIN: 'signin',
    SIGNUP: 'signup',
    CREATE_OR_UPDATE_GUEST: 'newguest',
    CONFIRMATION: 'confirmation',
    CREATE_ACTIVITY: 'createactivity',
    CANCEL_BOOKINGITEM: 'cancelboookingitem',
    EMAIL_PREVIEW: 'emailpreview',
    AVAILABLE_ADDONS: 'availableaddons',
    CREATE_TAG: 'createtag',
    MULTIPLE_TICKET: 'multipleticket',
    CONFIRM_OR_DENY_BOOKING: 'confirmordenybooking',
    AVAILABLE_TIMESLOTS: 'availabletimeslots',
    IMAGE_SLIDER_MODAL: 'imageslider',
    FULLSCREEN_MESSAGE_MODAL: 'fullscreenmessage',
    DUPLICATE_TICKET_MODAL: 'duplicateticket',
    RESEND_EMAIL_MODAL: 'resendemailmodal',
    CREATE_USERGROUP: 'createusergroup',
    CALENDAR_EVENT_INFO: 'calendareventinfo',
    KEEP_CART: 'keepcart',
    ADD_AGENT: 'addagent',
    ADD_AGENT_LIST: 'addagentlist',
    ACCEPT_BOOKING_NOTE: 'acceptbookingnote',
    UNSAVED_MODIFICATIONS: 'unsavedmodifications',
    CREATE_CHAIN: 'createchain',
    CREATE_ISLAND: 'createisland',
    CREATE_CANCEL_REASON: 'createcancelreason',
    IMPORT_ACTIVITY: 'importactivity',
    CREATE_DISCOUNTPACKAGE: 'creatediscountpackage',
    SELECT_PRINT: 'selectvoucherprint',
    DRAG_DROP: 'dragdrop',
    SEND_SMS: 'sendsms',
    BOOKING_ITEM_REFUND: 'bookingitemrefund',
    BOOKING_ITEM_TIME: 'bookingedittime',
    SHOW_TEST_ITINERARY: 'showtestitinerary',
    SEND_EMAIL: 'sendemail',
    CREATE_OR_EDIT_PRICE_ITEM_NAME: 'createorupdatepriceitemname',
    SEND_PAYMENT_LINK: 'sendpaymentlink',
    SOFT_LOCK: 'softlock',
    DASHBOARD_ALERTS: 'dashboardalerts',
    BULK_REFUND_CANCEL: 'bulkrefundcancel',
    NONE: false
};

const ModalContext = React.createContext();

export function ModalContextProvider({ children }) {
    const [modalState, setModalState] = useState({
        currentlyShowingModal: false, // name should be false
        props: {}
    });

    const showModal = useCallback(
        (currentlyShowingModal, newprops = {}) => {
            setModalState({
                currentlyShowingModal,
                props: newprops
            });
        },
        [setModalState]
    );
    // TODO: the next line might need some work so the object is memoized
    return (
        <ModalContext.Provider value={{ ...modalState, showModal }}>
            {children}
        </ModalContext.Provider>
    );
}
ModalContext.displayName = 'ModalContext';

export function Modals() {
    return (
        <ModalContext.Consumer>
            {context => {
                const allProps = {
                    ...context.props,
                    currentlyShowingModal: context.currentlyShowingModal,
                    showModal: context.showModal,
                    MODAL_TYPE
                };
                return (
                    <div>
                        {context.currentlyShowingModal === MODAL_TYPE.SIGNIN && (
                            <SignInModalContainer {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SIGNUP && (
                            <SignUpModalContainer {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.ADD_AGENT && (
                            <AddAgentModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.ADD_AGENT_LIST && (
                            <AddAgentListModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_OR_UPDATE_GUEST && (
                            <CreateOrUpdateGuestModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CONFIRMATION && (
                            <ConfirmationModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_ACTIVITY && (
                            <CreateNewActivityModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_TAG && (
                            <CreateNewActivityTagModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.EMAIL_PREVIEW && (
                            <EmaillogModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CANCEL_BOOKINGITEM && (
                            <CancellationModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.AVAILABLE_ADDONS && (
                            <AvailableAddonsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.MULTIPLE_TICKET && (
                            <MultipleTicketModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CONFIRM_OR_DENY_BOOKING && (
                            <ConfirmOrDenyBookingModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.AVAILABLE_TIMESLOTS && (
                            <AvailableTimeslotsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.IMAGE_SLIDER_MODAL && (
                            <ImageSliderModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.FULLSCREEN_MESSAGE_MODAL && (
                            <FullscreenMessageModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.DUPLICATE_TICKET_MODAL && (
                            <DuplicateTicketModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.RESEND_EMAIL_MODAL && (
                            <ResendEmailModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_USERGROUP && (
                            <CreateNewUserGroupModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CALENDAR_EVENT_INFO && (
                            <CalendarEventInfo {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.KEEP_CART && (
                            <KeepCartModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.ACCEPT_BOOKING_NOTE && (
                            <AcceptBookingNoteModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.UNSAVED_MODIFICATIONS && (
                            <UnsavedModificationsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_CHAIN && (
                            <CreateNewChainModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_ISLAND && (
                            <CreateNewIslandModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_CANCEL_REASON && (
                            <CreateNewCancelReasonModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CREATE_DISCOUNTPACKAGE && (
                            <CreateNewDiscountPackageModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.IMPORT_ACTIVITY && (
                            <ImportActivityModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SELECT_PRINT && (
                            <SelectPrintMethodModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.DRAG_DROP && (
                            <DragDropModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SEND_SMS && (
                            <SendSmsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SHOW_TEST_ITINERARY && (
                            <TestItineraryModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SEND_EMAIL && (
                            <SendEmailModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.BOOKING_ITEM_REFUND && (
                            <BookingEditRefundModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.BOOKING_ITEM_TIME && (
                            <BookingEditTimeModal {...allProps} />
                        )}
                        {context.currentlyShowingModal ===
                            MODAL_TYPE.CREATE_OR_EDIT_PRICE_ITEM_NAME && (
                            <CreateOrEditPriceItemNameModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SEND_PAYMENT_LINK && (
                            <SendPaymentLinkModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SOFT_LOCK && (
                            <SoftLockModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.DASHBOARD_ALERTS && (
                            <DashboardAlertsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.BULK_REFUND_CANCEL && (
                            <BulkRefundCancelModal {...allProps} />
                        )}
                    </div>
                );
            }}
        </ModalContext.Consumer>
    );
}

export function useModals() {
    return useContext(ModalContext);
}
